import { render } from "./MobileHome.vue?vue&type=template&id=a84c0a34&scoped=true"
import script from "./MobileHome.vue?vue&type=script&lang=js"
export * from "./MobileHome.vue?vue&type=script&lang=js"

import "./MobileHome.vue?vue&type=style&index=0&id=a84c0a34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a84c0a34"]])

export default __exports__